import MainMenu from '@/components/foundation/main-menu/MainMenu'
import EventDocuments from '@/view/event-documents/EventDocuments'

export const EventDocumentsRoute = {
  path: '/event/documents/:id',
  name: 'EventDocuments',
  components: {
    default: EventDocuments,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Evento',
        link: '/event'
      },
      {
        eventCode: 'Events/EVENT_CODE',
        isOpenClose: 'Events/IS_OPEN_CLOSE',
        clientName: 'Events/CLIENT_NAME',
        eventIdentification: 'Events/EVENT_IDENTIFICATION',
        linkGetter: 'Events/GET_EVENT_LINK'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/event/EventDocuments.js